import { User } from '../interfaces';
import client from './client';

const getUser = async (): Promise<User> => {
  const res = await client.get<User>(`/api/users/me`);

  return res.data;
};

const updateUserIsValidator = async (userId: number) => {
  const res = await client.put<any>(`/api/users/${userId}`, {
    isValidator: true,
  });

  return res;
};
const updateUser = async (data: any) => {
  const res = await client.put<any>(`/api/users/3`, data, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

  return res;
};

export { getUser, updateUserIsValidator, updateUser };
